document.addEventListener('DOMContentLoaded', () => {
    console.log('JS: DOMContentLoaded Fired. Initializing Feature Scroll Logic.');

    document.querySelectorAll('.feature-scroll-section').forEach(section => {
        const isMobile = window.innerWidth < 768;
        
        console.log(`JS: Processing Section ${section.id}. Is Mobile: ${isMobile}`);

        // ------------------------------------------------------------------
        // --- 1. DESKTOP LOGIK (BILDER FIX) ------------------------------
        // ------------------------------------------------------------------
        if (!isMobile) {
            const stickyWrapper = section.querySelector('#sticky-background-image');
            const textItems = section.querySelectorAll('.feature-scroll-section__text-item');
            
            if (!stickyWrapper || textItems.length === 0) {
                 console.warn(`JS Desktop: Skipping ${section.id}. Sticky wrapper or items missing.`);
                 return;
            }

            const updateDesktopImage = (index) => {
                const item = textItems[index];
                if (item) {
                    const imageUrl = item.dataset.imageUrl;
                    if (stickyWrapper.style.backgroundImage !== `url("${imageUrl}")`) {
                        stickyWrapper.style.backgroundImage = `url("${imageUrl}")`;
                    }
                }
            };

            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: Array.from({ length: 101 }, (_, i) => i / 100)
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const viewportHeight = window.innerHeight;
                        const elementTop = entry.boundingClientRect.top;
                        const elementHeight = entry.boundingClientRect.height;
                        const center = elementTop + (elementHeight / 2);
                        if (center > viewportHeight * 0.3 && center < viewportHeight * 0.7) {
                            const index = Array.from(textItems).indexOf(entry.target);
                            updateDesktopImage(index);
                        }
                    }
                });
            }, observerOptions);

            textItems.forEach(item => observer.observe(item));
            updateDesktopImage(0);
            return; 
        }

        // ------------------------------------------------------------------
        // --- 2. MOBILE LOGIK (CAROUSEL & BUTTON TOUCH FIX) ---------------
        // ------------------------------------------------------------------
        
        const sectionId = section.id;
        const MAX_OBSERVER_TIME = 5000;

        const initializeMobileCarousel = () => {
            const carouselContainer = section.querySelector('.feature-scroll-section__mobile-carousel');
            const arrowContainer = section.querySelector('.mobile-carousel-controls');
            const prevArrow = arrowContainer ? arrowContainer.querySelector('.carousel-arrow.prev') : null;
            const nextArrow = arrowContainer ? arrowContainer.querySelector('.carousel-arrow.next') : null;
            const textItems = section.querySelectorAll('.feature-scroll-section__text-item');

            if (!carouselContainer || !prevArrow || !nextArrow || textItems.length === 0) {
                 console.warn(`JS Mobile: Initialization failed for ${sectionId}. Elements not fully rendered.`);
                 return false;
            }
            
            console.log(`JS SUCCESS: Mobile Carousel initialized for ${sectionId}. Slides: ${textItems.length}`);
            
            const totalSlides = textItems.length;

            const getSlideWidth = () => {
                const width = textItems[0] ? textItems[0].clientWidth : window.innerWidth;
                return width > 0 ? width : window.innerWidth;
            }
            
            const updateArrows = () => {
                const scrollLeft = carouselContainer.scrollLeft;
                const slideWidth = getSlideWidth(); 
                if (slideWidth <= 1) return;
                const activeIndex = Math.round(scrollLeft / slideWidth); 
                prevArrow.classList.toggle('disabled', activeIndex === 0);
                nextArrow.classList.toggle('disabled', activeIndex === totalSlides - 1);
            };

            const handleArrowClick = (direction) => {
                const slideWidth = getSlideWidth();
                if (slideWidth <= 1 || (prevArrow.classList.contains('disabled') && direction === -1) || (nextArrow.classList.contains('disabled') && direction === 1)) return;
                
                const scrollLeft = carouselContainer.scrollLeft;
                let targetIndex = Math.round(scrollLeft / slideWidth) + direction;
                
                if (targetIndex < 0) targetIndex = 0;
                if (targetIndex >= totalSlides) targetIndex = totalSlides - 1;

                const targetScroll = targetIndex * slideWidth;
                
                carouselContainer.scrollTo({
                    left: targetScroll,
                    behavior: 'smooth'
                });
                
                setTimeout(updateArrows, 350); 
            };

            prevArrow.addEventListener('click', () => handleArrowClick(-1));
            nextArrow.addEventListener('click', () => handleArrowClick(1));

            let isScrolling;
            carouselContainer.addEventListener('scroll', () => {
                window.clearTimeout(isScrolling);
                isScrolling = setTimeout(updateArrows, 66); 
            });
            
            setTimeout(updateArrows, 50);
            window.addEventListener('resize', () => setTimeout(updateArrows, 100));

            // --- FIX: Touchstart stoppen, damit Buttonklicks im Carousel funktionieren ---
            section.querySelectorAll('.feature-scroll-section__text-item a').forEach(btn => {
                btn.addEventListener('touchstart', e => e.stopPropagation());
            });

            return true;
        };

        if (isMobile) {
            if (initializeMobileCarousel()) return;
            
            console.log(`JS Mobile: Attempting MutationObserver for delayed rendering...`);

            const observer = new MutationObserver((mutationsList, observer) => {
                if (initializeMobileCarousel()) {
                    observer.disconnect();
                    clearTimeout(timeoutId);
                    console.log(`JS Mobile: MutationObserver success! Initialized.`);
                }
            });

            observer.observe(section, { childList: true, subtree: true });

            const timeoutId = setTimeout(() => {
                observer.disconnect();
                if (!section.querySelector(`#mobile-carousel-${sectionId}`)) {
                     console.error(`JS Mobile: Initialization failed after ${MAX_OBSERVER_TIME / 1000}s timeout. Giving up.`);
                }
            }, MAX_OBSERVER_TIME);
        }
    });
});
